var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRobust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 9.84442C30.137 11.9154 40.401 15.7555 45.0788 15.7555V31.8C45.0788 37.5243 29.4347 45.9328 28.4998 46.1555C27.565 45.9328 11.9209 37.5243 11.9209 31.8V15.7555C16.5987 15.7555 26.8627 11.9154 28.4998 9.84442Z",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7535 25.0444H21.247C21.1834 25.0444 21.1318 25.0917 21.1318 25.15V35.9167C21.1318 35.975 21.1834 36.0222 21.247 36.0222H35.7535C35.8171 36.0222 35.8687 35.975 35.8687 35.9167V25.15C35.8687 25.0917 35.8171 25.0444 35.7535 25.0444Z",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8945 20.8222C23.8945 18.4905 25.9565 16.6 28.4998 16.6C31.0431 16.6 33.1051 18.4905 33.1051 20.8222V25.0444H23.8945V20.8222Z",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29.2667V31.8",
    stroke: "#0068B5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 38,
    fill: "white",
    transform: "translate(11 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRobust);
export default __webpack_public_path__ + "static/media/icon_robust.43c0771f8d329ce460d1ff042a744afc.svg";
export { ForwardRef as ReactComponent };